const middleware = {}

middleware['is-mobile'] = require('../middleware/is-mobile.js')
middleware['is-mobile'] = middleware['is-mobile'].default || middleware['is-mobile']

export default middleware
